import { hashString } from '../core/rng';

/** Daily Shift #1 was the night this game launched. */
const EPOCH = { year: 2026, month: 9, day: 26 };
const MS_PER_DAY = 86_400_000;

/**
 * Days since launch in the player's local calendar, so the daily shift rolls
 * over at their midnight (like Wordle), starting at #1.
 */
export function dailyShiftNumber(now: Date = new Date()): number {
  const today = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate());
  const epoch = Date.UTC(EPOCH.year, EPOCH.month - 1, EPOCH.day);
  return Math.max(1, Math.floor((today - epoch) / MS_PER_DAY) + 1);
}

export function dailySeed(shiftNumber: number): number {
  return hashString(`3am-shift:daily:${shiftNumber}`);
}

export function randomSeed(): number {
  return (Math.random() * 0xffffffff) >>> 0;
}
